import {parameterRange} from '../parameter/ParameterConstants'

// Use ".keyword" for search when type = "text, select, number"
// Remove ".keyword" when type = "boolean, !group"
// operators: [ 'some', 'all', 'none', ] is not work on elastic query
export const fieldList = {
    // User Info
    'username.keyword': {
        label: 'Username',
        label2: 'Username',
        type: 'text',
    },
    'firstName.keyword': {
        label: 'Firstname',
        label2: 'Firstname',
        type: 'text',
    },
    'lastName.keyword': {
        label: 'Lastname',
        label2: 'Lastname',
        type: 'text',
    },
    'email.keyword': {
        label: 'Email',
        label2: 'Email',
        type: 'text',
    },
    'code.keyword': {
        label: 'Code',
        label2: 'Code',
        type: 'text',
    },
    'nhsNumber.keyword': {
        label: 'NHS Number',
        label2: 'NHS Number',
        type: 'text',
    },
    'dob.keyword': {
        label: 'DOB',
        label2: 'DOB',
        type: 'text',
    },
    'gender.keyword': {
        label: 'Gender',
        label2: 'Gender',
        type: 'select',
        valueSources: ['value'],
        fieldSettings: {
            listValues: [
                {value: 'unknown', title: 'Unknown'},
                {value: 'male', title: 'Male'},
                {value: 'female', title: 'Female'},
                {value: 'indeterminate', title: 'Indeterminate'},
            ],
        },
    },
    'title.keyword': {
        label: 'Title',
        label2: 'Title',
        type: 'select',
        valueSources: ['value'],
        fieldSettings: {
            listValues: [
                {value: 'unknown', title: 'Unknown'},
                {value: 'mr', title: 'Mr'},
                {value: 'mrs', title: 'Mrs'},
                {value: 'miss', title: 'Miss'},
                {value: 'ms', title: 'Ms'},
                {value: 'sir', title: 'Sir'},
                {value: 'doctor', title: 'Doctor'},
                {value: 'nurse', title: 'Nurse'},
                {value: 'carer', title: 'Carer'},
                {value: 'madam', title: 'Madam'},
            ],
        },
    },

    // Additional Info
    'occupation.keyword': {
        label: 'Occupation',
        label2: 'Occupation',
        type: 'text',
    },
    'accommodationStatus.keyword': {
        label: 'Accommodation Status',
        label2: 'Accommodation Status',
        type: 'select',
        valueSources: ['value'],
        fieldSettings: {
            listValues: [
                {value: 'unknown', title: 'Unknown'},
                {
                    value: 'patientHasOwnStableAccommodationEgHomeflat',
                    title: 'Patient has own stable accommodation e.g. home/flat',
                },
                {
                    value: 'wardenControlledAccommodation',
                    title: 'Warden controlled accommodation',
                },
                {
                    value: 'residentialInstitutionWithoutRoutineNursingCare',
                    title: 'Residential institution WITHOUT routine nursing care',
                },
                {
                    value: 'residentialInstitutionWithRoutineNursingCare',
                    title: 'Residential institution WITH routine nursing care',
                },
                {value: 'medicalArea', title: 'Medical area'},
                {
                    value: 'homelessInNightShelter',
                    title: 'Homeless in night shelter',
                },
                {
                    value: 'homelessWithoutAccommodation',
                    title: 'Homeless without accommodation',
                },
                {
                    value: 'usualAccommodationNotGivenPatientRefused',
                    title: 'Usual accommodation not given : patient refused',
                },
                {
                    value: 'usualAccommodationNotGivenPatientPhysicallyUnable',
                    title: 'Usual accommodation not given : patient physically unable',
                },
                {
                    value: 'usualAccommodationNotKnown',
                    title: 'Usual accommodation not known',
                },
            ],
        },
    },
    'religion.keyword': {
        label: 'Religion',
        label2: 'Religion',
        type: 'select',
        valueSources: ['value'],
        fieldSettings: {
            listValues: [
                {value: 'none', title: 'none'},
                {value: 'nkNotKnown', title: 'NK (Not Known)'},
                {value: 'baBaptist', title: 'BA (Baptist)'},
                {value: 'buBuddhist', title: 'BU (Buddhist)'},
                {
                    value: 'ceChurchOfEngland',
                    title: 'CE (Church of England)',
                },
                {
                    value: 'chChristianScientist',
                    title: 'CH (Christian Scientist)',
                },
                {
                    value: 'ciChurchOfIreland',
                    title: 'CI (Church of Ireland)',
                },
                {
                    value: 'csChurchOfScotland',
                    title: 'CS (Church of Scotland)',
                },
                {value: 'ctChristian', title: 'CT (Christian)'},
                {
                    value: 'cwChurchOfWales',
                    title: 'CW (Church of Wales)',
                },
                {value: 'hiHindu', title: 'HI (Hindu)'},
                {value: 'jeJewish', title: 'JE (Jewish)'},
                {
                    value: 'jwJehovahsWitness',
                    title: 'JW (Jehovahs Witness)',
                },
                {value: 'meMethodist', title: 'ME (Methodist)'},
                {value: 'moMormon', title: 'MO (Mormon)'},
                {value: 'muMuslim', title: 'MU (Muslim)'},
                {
                    value: 'ncNonConformist',
                    title: 'NC (Non Conformist)',
                },
                {value: 'nrNoReligion', title: 'NR (No Religion)'},
                {
                    value: 'ofOtherFreeChurch',
                    title: 'OF (Other Free Church)',
                },
                {value: 'otOther', title: 'OT (Other)'},
                {
                    value: 'pbPlymouthBrethren',
                    title: 'PB (Plymouth Brethren)',
                },
                {
                    value: 'prPresbyterian',
                    title: 'PR (Presbyterian)',
                },
                {value: 'quQuaker', title: 'QU (Quaker)'},
                {
                    value: 'rcRomanCatholic',
                    title: 'RC (Roman Catholic)',
                },
                {
                    value: 'saSalvationArmy',
                    title: 'SA (Salvation Army)',
                },
            ],
        },
    },
    'maritalStatus.keyword': {
        label: 'Marital Status',
        label2: 'Marital Status',
        type: 'select',
        valueSources: ['value'],
        fieldSettings: {
            listValues: [
                {value: 'uUnknown', title: 'U (Unknown)'},
                {value: 'aSeparated', title: 'A (Separated)'},
                {value: 'dDivorced', title: 'D (Divorced)'},
                {
                    value: 'mMarriedCivilPartner',
                    title: 'M (Married/Civil Partner)',
                },
                {value: 'sSingle', title: 'S (Single)'},
                {value: 'wWidowed', title: 'W (Widowed)'},
                {
                    value: 'xNotDisclosed',
                    title: 'X (Not Disclosed)',
                },
            ],
        },
    },
    'diagnostic.keyword': {
        label: 'Diagnostic',
        label2: 'Diagnostic',
        type: 'select',
        valueSources: ['value'],
        fieldSettings: {
            listValues: [
                {value: 'unknown', title: 'Unknown'},
                {
                    value: 'airwayBreathing',
                    title: 'Airway / Breathing',
                },
                {
                    value: 'circulationChest',
                    title: 'Circulation / Chest',
                },
                {
                    value: 'gastrointestinal',
                    title: 'Gastrointestinal',
                },
                {value: 'neurological', title: 'Neurological'},
                {value: 'skin', title: 'Skin'},
                {value: 'headAndNeck', title: 'Head and Neck'},
                {value: 'eye', title: 'Eye'},
                {
                    value: 'traumaMusculoskeletal',
                    title: 'Trauma / Musculoskeletal',
                },
                {value: 'genitourinary', title: 'Genitourinary'},
                {value: 'obgyn', title: 'ObGyn'},
                {value: 'environmental', title: 'Environmental'},
                {
                    value: 'psychosocialBehaviourChange',
                    title: 'Psychosocial / Behaviour Change',
                },
                {
                    value: 'generalMinorAdmin',
                    title: 'General / Minor / Admin',
                },
                {value: 'chestPain', title: 'Chest Pain'},
                {value: 'palpitations', title: 'Palpitations'},
                {
                    value: 'electricalExposureIncLightning',
                    title: 'Electrical Exposure (inc. lightning)',
                },
                {value: 'hypothermia', title: 'Hypothermia'},
                {value: 'frostbite', title: 'Frostbite'},
                {value: 'cardiacArrest', title: 'Cardiac Arrest'},
                {value: 'nearDrowning', title: 'Near Drowning'},
                {
                    value: 'exposureToCommunicableDiseaseIncNeedlestickBodyFluids',
                    title: 'Exposure to Communicable Disease (inc. needlestick / body fluids)',
                },
                {
                    value: 'chemicalExposure',
                    title: 'Chemical Exposure',
                },
                {
                    value: 'noxiousInhalationGasFumesVapourSmoke',
                    title: 'Noxious Inhalation - Gas / Fumes / Vapour / Smoke',
                },
                {
                    value: 'poisoningFromAnySource',
                    title: 'Poisoning from Any Source',
                },
                {value: 'redEye', title: 'Red Eye'},
                {
                    value: 'foreignBodyOnEye',
                    title: 'Foreign Body on Eye',
                },
                {
                    value: 'painInAroundEye',
                    title: 'Pain In / Around Eye',
                },
                {
                    value: 'dischargeFromEye',
                    title: 'Discharge from Eye',
                },
                {
                    value: 'visualDisturbance',
                    title: 'Visual Disturbance',
                },
                {value: 'photophobia', title: 'Photophobia'},
                {value: 'eyeInjury', title: 'Eye Injury'},
                {value: 'eyeReview', title: 'Eye Review'},
                {value: 'abdominalPain', title: 'Abdominal Pain'},
                {
                    value: 'exportConstipation',
                    title: 'export Constipation',
                },
                {value: 'diarrhoea', title: 'Diarrhoea'},
                {
                    value: 'vomitingNausea',
                    title: 'Vomiting + / - Nausea',
                },
                {
                    value: 'nauseaWithoutVomiting',
                    title: 'Nausea Without Vomiting',
                },
                {value: 'hiccoughs', title: 'Hiccoughs'},
                {value: 'jaundice', title: 'Jaundice'},
                {
                    value: 'lossOfAppetite',
                    title: 'Loss of Appetite',
                },
                {value: 'vomitingBlood', title: 'Vomiting Blood'},
                {value: 'rectalPain', title: 'Rectal Pain'},
                {value: 'bloodInStools', title: 'Blood in Stools'},
                {value: 'injuryOfAnus', title: 'Injury of Anus'},
                {
                    value: 'foodForeignBodyInOesophagus',
                    title: 'Food / Foreign Body in Oesophagus',
                },
                {
                    value: 'foreignBodyInDigestiveTract',
                    title: 'Foreign Body in Digestive Tract',
                },
                {
                    value: 'foreignBodyInRectum',
                    title: 'Foreign Body in Rectum',
                },
                {
                    value: 'abdominalDistension',
                    title: 'Abdominal Distension',
                },
                {
                    value: 'difficultySwallowing',
                    title: 'Difficulty Swallowing',
                },
                {value: 'fever', title: 'Fever'},
                {value: 'hyperglycaemia', title: 'Hyperglycaemia'},
                {value: 'hypoglycaemia', title: 'Hypoglycaemia'},
                {
                    value: 'postoperativeWoundCareNoComplication',
                    title: 'Postoperative / wound care (no complication)',
                },
                {
                    value: 'postoperativeMedicalDeviceWithComplication',
                    title: 'Postoperative / Medical Device with Complication',
                },
                {value: 'cryingInfant', title: 'Crying Infant'},
                {
                    value: 'generalisedWeakness',
                    title: 'Generalised Weakness',
                },
                {value: 'paleColour', title: 'Pale Colour'},
                {
                    value: 'asymptomaticNoSymptoms',
                    title: 'Asymptomatic, No Symptoms',
                },
                {
                    value: 'blueColourCyanosis',
                    title: 'Blue Colour (cyanosis)',
                },
                {
                    value: 'socialProblemMedicallyWell',
                    title: 'Social Problem (medically well)',
                },
                {
                    value: 'directReferralToInpatientUnit',
                    title: 'Direct Referral to Inpatient Unit',
                },
                {
                    value: 'requestingPrescription',
                    title: 'Requesting Prescription',
                },
                {
                    value: 'painOnPassingUrine',
                    title: 'Pain on Passing Urine',
                },
                {
                    value: 'frequentUrination',
                    title: 'Frequent Urination',
                },
                {
                    value: 'unableToPassUrine',
                    title: 'Unable to Pass Urine',
                },
                {
                    value: 'lowUrineOutput',
                    title: 'Low Urine Output',
                },
                {value: 'bloodInUrine', title: 'Blood in Urine'},
                {value: 'flankPain', title: 'Flank Pain'},
                {
                    value: 'painInScrotumTestes',
                    title: 'Pain in Scrotum / Testes',
                },
                {
                    value: 'abnormalSwellingGroinArea',
                    title: 'Abnormal Swelling Groin Area',
                },
                {
                    value: 'painInGenitalAreaGeneralised',
                    title: 'Pain in Genital Area (generalised)',
                },
                {
                    value: 'injuryToGenitalArea',
                    title: 'Injury to Genital Area',
                },
                {
                    value: 'problemRelatedToPenis',
                    title: 'Problem Related to Penis',
                },
                {
                    value: 'statesVictimOfSexualAssault',
                    title: 'States Victim of Sexual Assault',
                },
                {
                    value: 'facialPainIncToothache',
                    title: 'Facial Pain (inc. toothache)',
                },
                {value: 'neckPain', title: 'Neck Pain'},
                {value: 'earPain', title: 'Ear : Pain'},
                {value: 'earInjury', title: 'Ear : Injury'},
                {value: 'earDischarge', title: 'Ear : Discharge'},
                {
                    value: 'earHearingLoss',
                    title: 'Ear : Hearing Loss',
                },
                {
                    value: 'earRingingInEarsTinnitus',
                    title: 'Ear : Ringing in Ears (tinnitus)',
                },
                {
                    value: 'earForeignBody',
                    title: 'Ear : Foreign Body',
                },
                {
                    value: 'noseBleedingFromNose',
                    title: 'Nose : Bleeding from Nose',
                },
                {value: 'noseInjury', title: 'Nose : Injury'},
                {
                    value: 'noseCongestion',
                    title: 'Nose : Congestion',
                },
                {
                    value: 'noseForeignBody',
                    title: 'Nose : Foreign Body',
                },
                {
                    value: 'throatSwelling',
                    title: 'Throat : Swelling',
                },
                {value: 'throatSore', title: 'Throat : Sore'},
                {value: 'throatCough', title: 'Throat : Cough'},
                {
                    value: 'throatForeignBodyInThroatMouth',
                    title: 'Throat : Foreign Body in Throat / Mouth',
                },
                {value: 'headache', title: 'Headache'},
                {value: 'confusion', title: 'Confusion'},
                {
                    value: 'drowsyAlteredLevelOfConsciousness',
                    title: 'Drowsy (altered level of consciousness)',
                },
                {value: 'limbWeakness', title: 'Limb Weakness'},
                {value: 'facialWeakness', title: 'Facial Weakness'},
                {
                    value: 'speechDisturbance',
                    title: 'Speech Disturbance',
                },
                {value: 'seizureFit', title: 'Seizure (fit)'},
                {value: 'dizziness', title: 'Dizziness'},
                {
                    value: 'numbnessTinglingParasthesia',
                    title: 'Numbness / Tingling (parasthesia)',
                },
                {value: 'tremor', title: 'Tremor'},
                {
                    value: 'fallsUnsteadyOnFeet',
                    title: 'Falls / Unsteady on Feet',
                },
                {value: 'insomnia', title: 'Insomnia'},
                {value: 'shortOfBreath', title: 'Short of Breath'},
                {
                    value: 'difficultyBreathing',
                    title: 'Difficulty Breathing',
                },
                {value: 'noisyBreathing', title: 'Noisy Breathing'},
                {
                    value: 'collapseFaintingEpisode',
                    title: 'Collapse / Fainting Episode',
                },
                {
                    value: 'collapseFaintingEpisodeWithLossOfConsciousness',
                    title: 'Collapse / Fainting Episode with Loss of Consciousness',
                },
                {
                    value: 'coughingUpBloodHaemoptysis',
                    title: 'Coughing up Blood (haemoptysis)',
                },
                {
                    value: 'swollenLegsBoth',
                    title: 'Swollen Legs (both)',
                },
                {
                    value: 'swollenLegSingle',
                    title: 'Swollen Leg (single)',
                },
                {
                    value: 'coldPainfulLimb',
                    title: 'Cold Painful Limb',
                },
                {
                    value: 'foreignBodyInRespiratoryTract',
                    title: 'Foreign Body in Respiratory Tract',
                },
                {
                    value: 'cardiacArrestDueToTrauma',
                    title: 'Cardiac Arrest Due to Trauma',
                },
                {
                    value: 'infantWithEpisodesNotBreathingApnoea',
                    title: 'Infant with Episodes not Breathing (apnoea)',
                },
                {
                    value: 'respiratoryArrest',
                    title: 'Respiratory Arrest',
                },
                {
                    value: 'pregnancyRelatedLessThan20Weeks',
                    title: 'Pregnancy Related : Less Than 20 Weeks',
                },
                {
                    value: 'pregnancyRelatedGreaterThan20Weeks',
                    title: 'Pregnancy Related : Greater Than 20 Weeks',
                },
                {
                    value: 'vaginalBleedingAbnormal',
                    title: 'Vaginal Bleeding (abnormal)',
                },
                {
                    value: 'foreignBodyInVagina',
                    title: 'Foreign Body in Vagina',
                },
                {
                    value: 'problemRelatedToVagina',
                    title: 'Problem Related to Vagina',
                },
                {
                    value: 'problemRelatedToBreast',
                    title: 'Problem Related to Breast',
                },
                {
                    value: 'drugAlcoholIntoxicationOrWithdrawal',
                    title: 'Drug / Alcohol Intoxication or Withdrawal',
                },
                {value: 'selfharm', title: 'Self-harm'},
                {
                    value: 'suicidalThoughts',
                    title: 'Suicidal Thoughts',
                },
                {
                    value: 'depressiveFeelings',
                    title: 'Depressive Feelings',
                },
                {value: 'feelingAnxious', title: 'Feeling Anxious'},
                {
                    value: 'behaviourUnusual',
                    title: 'Behaviour : Unusual',
                },
                {
                    value: 'behaviourAgitatedViolent',
                    title: 'Behaviour : Agitated / Violent',
                },
                {
                    value: 'hallucinationsDelusions',
                    title: 'Hallucinations / Delusions',
                },
                {value: 'woundAbrasion', title: 'Wound : Abrasion'},
                {
                    value: 'woundLaceration',
                    title: 'Wound : Laceration',
                },
                {value: 'woundPuncture', title: 'Wound : Puncture'},
                {value: 'woundSting', title: 'Wound : Sting'},
                {value: 'woundBite', title: 'Wound : Bite'},
                {value: 'burn', title: 'Burn'},
                {value: 'rash', title: 'Rash'},
                {
                    value: 'localisedSwellingRednessLumpsBumps',
                    title: 'Localised Swelling / Redness / Lumps / Bumps',
                },
                {value: 'itching', title: 'Itching'},
                {
                    value: 'spontaneousBruising',
                    title: 'Spontaneous Bruising',
                },
                {
                    value: 'foreignBodyInSkinSubcutaneousTissue',
                    title: 'Foreign Body in Skin / Subcutaneous Tissue',
                },
                {value: 'headInjury', title: 'Head Injury'},
                {value: 'facialInjury', title: 'Facial Injury'},
                {value: 'injuryOfNeck', title: 'Injury of Neck'},
                {
                    value: 'injuryOfShoulderArmElbowWristHand',
                    title: 'Injury of Shoulder / Arm / Elbow / Wrist / Hand',
                },
                {
                    value: 'injuryOfHipLegKneeAnkleFoot',
                    title: 'Injury of Hip / Leg / Knee / Ankle / Foot',
                },
                {
                    value: 'injuryOfThorax',
                    title: 'Injury of Thorax',
                },
                {
                    value: 'injuryOfAbdomen',
                    title: 'Injury of Abdomen',
                },
                {
                    value: 'injuryOfCervicalRegionOfBackDisorder',
                    title: 'Injury of Cervical Region of Back (disorder)',
                },
                {
                    value: 'injuryOfUpperBack',
                    title: 'Injury of Upper Back',
                },
                {
                    value: 'backacheNoRecentInjury',
                    title: 'Backache (no recent injury)',
                },
                {
                    value: 'painInShoulderArmElbowWristHand',
                    title: 'Pain in Shoulder / Arm / Elbow / Wrist / Hand',
                },
                {
                    value: 'painInHipLegKneeAnkleFoot',
                    title: 'Pain in Hip / Leg / Knee / Ankle / Foot',
                },
                {value: 'jointSwelling', title: 'Joint Swelling'},
                {
                    value: 'majorTraumaSeriousInjuryGt1BodyArea',
                    title: 'Major Trauma (serious injury GT1 body area)',
                },
                {
                    value: 'traumaticAmputation',
                    title: 'Traumatic Amputation',
                },
            ],
        },
    },
    'identityWithHeldReason.keyword': {
        label: 'Identity With Held Reason',
        label2: 'Identity With Held Reason',
        type: 'select',
        valueSources: ['value'],
        fieldSettings: {
            listValues: [
                {value: 'unknown', title: 'Unknown'},
                {
                    value: 'recordAnonymisedForLegalstatutoryReasons',
                    title: 'Record anonymised for legal/statutory reasons',
                },
                {
                    value: 'recordAnonymisedAtRequestOfCaldicottGuardian',
                    title: 'Record anonymised at request of Caldicott Guardian',
                },
                {
                    value: 'recordAnonymisedAtRequestOfPatient',
                    title: 'Record anonymised at request of PATIENT',
                },
                {
                    value: 'recordAnonymisedForOtherReason',
                    title: 'Record anonymised for other reason',
                },
            ],
        },
    },

    // Address
    'addressLine1.keyword': {
        label: 'Address Line 1',
        label2: 'Address Line 1',
        type: 'text',
    },
    'addressLine2.keyword': {
        label: 'Address Line 2',
        label2: 'Address Line 2',
        type: 'text',
    },
    'addressLine3.keyword': {
        label: 'Address Line 3',
        label2: 'Address Line 3',
        type: 'text',
    },
    'addressLine4.keyword': {
        label: 'Address Line 4',
        label2: 'Address Line 4',
        type: 'text',
    },
    'city.keyword': {
        label: 'City',
        label2: 'City',
        type: 'text',
    },
    'state.keyword': {
        label: 'State',
        label2: 'State',
        type: 'text',
    },
    'country.keyword': {
        label: 'Country',
        label2: 'Country',
        type: 'text',
    },
    'postalCode.keyword': {
        label: 'Postal Code',
        label2: 'Postal Code',
        type: 'text',
    },
    'phone.keyword': {
        label: 'Phone',
        label2: 'Phone',
        type: 'text',
    },

    // User Status
    deleted: {
        label: 'Deleted Status',
        label2: 'Deleted Status',
        type: 'boolean',
        operators: ['equal'],
        valueSources: ['value'],
    },
    active: {
        label: 'Active Status',
        label2: 'Active Status',
        type: 'boolean',
        operators: ['equal'],
        valueSources: ['value'],
    },

    // PATHWAYS
    pathways: {
        label: 'Pathways',
        label2: 'Pathways',
        tooltip: 'Group of fields',
        type: '!group',
        mode: 'array',
        conjunctions: ['AND', 'OR'],
        showNot: true,
        operators: [
            //     // w/o operand
            //     'some',
            'all',
            //     'none',
        ],
        defaultOperator: 'some',
        initialEmptyWhere: true, // if default operator is not in config.settings.groupOperators, true - to set no children, false - to add 1 empty
        subfields: {
            'name.keyword': {
                label: 'Name',
                label2: 'Name',
                type: 'text',
            },
            'code.keyword': {
                label: 'Code',
                label2: 'Code',
                type: 'text',
            },
        },
    },

    abnormality: {
        label: 'Abnormalities',
        label2: 'Abnormalities',
        tooltip: 'Group of fields',
        type: '!group',
        mode: 'array',
        conjunctions: ['AND', 'OR'],
        showNot: true,
        operators: [
            //     // w/o operand
            //     'some',
            'all',
            //     'none',
        ],
        defaultOperator: 'some',
        initialEmptyWhere: true, // if default operator is not in config.settings.groupOperators, true - to set no children, false - to add 1 empty

        subfields: {
            'lower.keyword': {
                label: 'Lower than Parameter',
                label2: 'Lower than Parameter',
                type: 'select',
                valueSources: ['value'],
                operators: ['select_any_in', 'select_not_any_in'],
                fieldSettings: {
                    listValues: [
                        {value: 'heartrate', title: 'Heart Rate'},
                        {value: 'respiration', title: 'Respiration'},
                        {value: 'temperature', title: 'Temperature'},
                        {value: 'systolic', title: 'Systolic'},
                        {value: 'oxygen', title: 'Oxygen'},
                        {value: 'glucose', title: 'Glucose'},
                    ],
                },
            },
            'upper.keyword': {
                label: 'Upper than Parameter',
                label2: 'Upper than Parameter',
                type: 'select',
                valueSources: ['value'],
                operators: ['select_any_in', 'select_not_any_in'],
                fieldSettings: {
                    listValues: [
                        {value: 'heartrate', title: 'Heart Rate'},
                        {value: 'respiration', title: 'Respiration'},
                        {value: 'temperature', title: 'Temperature'},
                        {value: 'systolic', title: 'Systolic'},
                        {value: 'oxygen', title: 'Oxygen'},
                        {value: 'glucose', title: 'Glucose'},
                    ],
                },
            },
        },
    },

    // HEALTH RECORDS
    healthRecords: {
        label: 'Health Records',
        label2: 'Health Records',
        tooltip: 'Group of fields',
        type: '!group',
        mode: 'array',
        conjunctions: ['AND', 'OR'],
        showNot: true,
        operators: [
            //     // w/o operand
            //     'some',
            'all',
            //     'none',
        ],
        defaultOperator: 'some',
        initialEmptyWhere: true, // if default operator is not in config.settings.groupOperators, true - to set no children, false - to add 1 empty

        subfields: {
            'heartRate.keyword': {
                label: 'Heart Rate (BPM)',
                label2: 'Heart Rate (BPM)',
                type: 'number',
                valueSources: ['value'],
                fieldSettings: {
                    min: parameterRange.heartRate.min,
                    max: parameterRange.heartRate.max,
                },
                preferWidgets: ['slider', 'rangeslider'],
            },
            'respiration.keyword': {
                label: 'Respiration (BPM)',
                label2: 'Respiration (BPM)',
                type: 'number',
                valueSources: ['value'],
                fieldSettings: {
                    min: parameterRange.respiration.min,
                    max: parameterRange.respiration.max,
                },
                preferWidgets: ['slider', 'rangeslider'],
            },
            'oxygen.keyword': {
                label: 'Oxygen Saturation ( % )',
                label2: 'Oxygen Saturation ( % )',
                type: 'number',
                valueSources: ['value'],
                fieldSettings: {
                    min: parameterRange.oxygen.min,
                    max: parameterRange.oxygen.max,
                },
                preferWidgets: ['slider', 'rangeslider'],
            },
            'temperature.keyword': {
                label: 'Temperature ( °C )',
                label2: 'Temperature ( °C )',
                type: 'number',
                valueSources: ['value'],
                fieldSettings: {
                    min: parameterRange.temperature.min,
                    max: parameterRange.temperature.max,
                },
                preferWidgets: ['slider', 'rangeslider'],
            },
            'systolic.keyword': {
                label: 'Systolic ( mm/Hg )',
                label2: 'Systolic ( mm/Hg )',
                type: 'number',
                valueSources: ['value'],
                fieldSettings: {
                    min: parameterRange.systolic.min,
                    max: parameterRange.systolic.max,
                },
                preferWidgets: ['slider', 'rangeslider'],
            },
            'diastolic.keyword': {
                label: 'Diastolic ( mm/Hg )',
                label2: 'Diastolic ( mm/Hg )',
                type: 'number',
                valueSources: ['value'],
                fieldSettings: {
                    min: 30,
                    max: 140,
                },
                preferWidgets: ['slider', 'rangeslider'],
            },
            'litres.keyword': {
                label: 'Litres (L)',
                label2: 'Litres (L)',
                type: 'number',
                valueSources: ['value'],
                fieldSettings: {
                    min: 0,
                    max: 15,
                },
                preferWidgets: ['slider', 'rangeslider'],
            },
            // 'bloodPressureLimb.keyword': {
            //     label: 'Blood Pressure Limb',
            //     label2: 'Blood Pressure Limb',
            //     type: 'select',
            //     valueSources: ['value'],
            //     fieldSettings: {
            //         listValues: [
            //             {value: 'unknown', title: 'Unknown'},
            //             {value: 'male', title: 'Male'},
            //             {value: 'female', title: 'Female'},
            //             {value: 'indeterminate', title: 'Indeterminate'},
            //         ],
            //     },
            // },
            // bloodPressurePosition: {
            //     label: 'Blood Pressure Position',
            //     label2: 'Blood Pressure Position',
            //     type: 'select',
            //     valueSources: ['value'],
            //     fieldSettings: {
            //         listValues: [
            //             {value: 'unknown', title: 'Unknown'},
            //             {value: 'male', title: 'Male'},
            //             {value: 'female', title: 'Female'},
            //             {value: 'indeterminate', title: 'Indeterminate'},
            //         ],
            //     },
            // },
            // levelOfConsciousness: {
            //     label: 'Level Of Consciousness',
            //     label2: 'Level Of Consciousness',
            //     type: 'select',
            //     valueSources: ['value'],
            //     fieldSettings: {
            //         listValues: [
            //             {value: 'unknown', title: 'Unknown'},
            //             {value: 'male', title: 'Male'},
            //             {value: 'female', title: 'Female'},
            //             {value: 'indeterminate', title: 'Indeterminate'},
            //         ],
            //     },
            // },
            confusion: {
                label: 'Confusion',
                label2: 'Confusion',
                type: 'boolean',
                operators: ['equal'],
                valueSources: ['value'],
            },
            'bloodGlucoseLevel.keyword': {
                label: 'Blood Glucose Level ( mmol/L )',
                label2: 'Blood Glucose Level ( mmol/L )',
                type: 'number',
                valueSources: ['value'],
                fieldSettings: {
                    min: 0,
                    max: 30,
                },
                preferWidgets: ['slider', 'rangeslider'],
            },
            'painScore.keyword': {
                label: 'Pain Score',
                label2: 'Pain Score',
                type: 'number',
                valueSources: ['value'],
                fieldSettings: {
                    min: 0,
                    max: 10,
                },
                preferWidgets: ['slider', 'rangeslider'],
            },
            'tas.keyword': {
                label: 'TAS',
                label2: 'TAS',
                type: 'number',
                valueSources: ['value'],
                fieldSettings: {
                    min: 0,
                },
                preferWidgets: ['slider', 'rangeslider'],
            },
            'news.keyword': {
                label: 'NEWS',
                label2: 'NEWS',
                type: 'number',
                valueSources: ['value'],
                fieldSettings: {
                    min: 0,
                    max: 18,
                },
                preferWidgets: ['slider', 'rangeslider'],
            },
            'calories.keyword': {
                label: 'Calories',
                label2: 'Calories',
                type: 'number',
                valueSources: ['value'],
                fieldSettings: {
                    min: 0,
                },
                preferWidgets: ['slider', 'rangeslider'],
            },
            'steps.keyword': {
                label: 'Steps',
                label2: 'Steps',
                type: 'number',
                valueSources: ['value'],
                fieldSettings: {
                    min: parameterRange.steps.min,
                    max: parameterRange.steps.max,
                },
                preferWidgets: ['slider', 'rangeslider'],
            },
            sleep: {
                label: 'Sleep',
                label2: 'Sleep',
                type: 'number',
                valueSources: ['value'],
                fieldSettings: {
                    min: parameterRange.sleep.min,
                    max: parameterRange.sleep.max,
                },
                preferWidgets: ['slider', 'rangeslider'],
            },
            'sleepSegment.keyword': {
                label: 'Sleep Segment',
                label2: 'Sleep Segment',
                type: 'text',
            },
            'sleepClassify.keyword': {
                label: 'Sleep Classify',
                label2: 'Sleep Classify',
                type: 'text',
            },
            seizure: {
                label: 'Seizure',
                label2: 'Seizure',
                type: 'boolean',
                operators: ['equal'],
                valueSources: ['value'],
            },
            fall: {
                label: 'Fall',
                label2: 'Fall',
                type: 'boolean',
                operators: ['equal'],
                valueSources: ['value'],
            },
            'comment.keyword': {
                label: 'Comment',
                label2: 'Comment',
                type: 'text',
            },
            // 'device': {
            //     label: 'Device',
            //     label: 'Device',
            //     type: 'select',
            //     valueSources: ['value'],
            //     fieldSettings: {
            //         listValues: [
            //             {value: 'unknown', title: 'Unknown'},
            //             {value: 'male', title: 'Male'},
            //             {value: 'female', title: 'Female'},
            //             {value: 'indeterminate', title: 'Indeterminate'},
            //         ],
            //     },
            // },
            'longitude.keyword': {
                label: 'Longitude',
                label2: 'Longitude',
                type: 'number',
                valueSources: ['value'],
                fieldSettings: {
                    min: 0,
                },
                preferWidgets: ['slider', 'rangeslider'],
            },
            'latitude.keyword': {
                label: 'Latitude',
                label2: 'Latitude',
                type: 'number',
                valueSources: ['value'],
                fieldSettings: {
                    min: 0,
                },
                preferWidgets: ['slider', 'rangeslider'],
            },
        },
    },
}

export const dataColumns = [
    {
        key: 'hospitalName',
    },
    {
        key: 'hospitalNumber',
    },
    {
        key: 'username',
    },
    {
        key: 'firstName',
    },
    {
        key: 'lastName',
    },
    {
        key: 'email',
    },
    {
        key: 'gender',
    },
    {
        key: 'title',
    },
    {
        key: 'dob',
    },
    {
        key: 'userCode',
    },
    {
        key: 'accessCode',
    },
    {
        key: 'active',
    },
    {
        key: 'deleted',
    },
    {
        key: 'assigned',
    },
    {
        key: 'identityWithHeldReason',
    },
    {
        key: 'occupation',
    },
    {
        key: 'maritalStatus',
    },
    {
        key: 'religion',
    },
    {
        key: 'accommodationStatus',
    },
    {
        key: 'diagnostic',
    },
    {
        key: 'addressLine1',
    },
    {
        key: 'addressLine2',
    },
    {
        key: 'addressLine3',
    },
    {
        key: 'addressLine4',
    },
    {
        key: 'city',
    },
    {
        key: 'state',
    },
    {
        key: 'country',
    },
    {
        key: 'postalCode',
    },
    {
        key: 'phone',
    },
]

export const genderList = [
    {label: 'Unknown', value: 'unknown'},
    {label: 'Male', value: 'male'},
    {label: 'Female', value: 'female'},
    {label: 'Indeterminate', value: 'indeterminate'},
]
